import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { inIframe, isJSON } from '../../utils';
import { getContentCompletionData, getUserName, isAdmin } from '../../hooks';

export const ProgramsBox = (props) => {
  const { t } = useTranslation('library');

  const getProgramID = (programData:any) =>{
    if(props?.isAssignedProgram && String(programData?.program_key).includes("+")){
      return String(programData?.program_key).split("+")[1]
    }
    return programData?.program_id
  }

  return (
    <>
      {!inIframe() && !props?.isAssignedProgram &&
        (!isAdmin() ||
          process.env.REACT_APP_IBL_APP_ENABLE_CREATE_BUTTONS !== 'true') && (
          <div
            id="w-node-f31e1962-462b-8b0d-0045-72a4bb836b6c-a52aa012"
            className="item-box path_box custom_box"
          >
            <Link to="/discover" className="link-block-31 w-inline-block">
              <div className="div-block-444">
                <div className="div-block-394">
                  <img
                    src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66babee_plus.png"
                    loading="lazy"
                    alt=""
                    className="image-142"
                  />
                </div>
                <div className="c_p">{t('Discover Programs')}</div>
              </div>
            </Link>
          </div>
        )}

      {isAdmin() &&
        !inIframe() &&
        process.env.REACT_APP_IBL_APP_ENABLE_CREATE_BUTTONS === 'true' && (
          <div
            id="w-node-f31e1962-462b-8b0d-0045-72a4bb836b6c-a52aa012"
            className="item-box path_box custom_box"
          >
            <Link
              to={`${process.env.REACT_APP_IBL_STUDIO_URL}`}
              className="link-block-31 w-inline-block"
            >
              <div className="div-block-444">
                <div className="div-block-394">
                  <img
                    src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66babee_plus.png"
                    loading="lazy"
                    alt=""
                    className="image-142"
                  />
                </div>
                <div className="c_p">{t('Create Program')}</div>
              </div>
            </Link>
          </div>
        )}
      {props.profileProgramsLoaded &&
        props.profilePrograms.map((pathway, index) => {
          const data = isJSON(pathway?.data) ? JSON.parse(pathway.data) : {};
          const url = `${props?.includeProfilePath ? "/profile" : ""}/programs/${getProgramID(pathway)}`
          return (
            <SingleProgramBox programData={pathway} index={index} url={url} data={data} showProgressBar={props?.showProgressBar} />
          );
        })}
    </>
  );
};

const SingleProgramBox = ({programData, url, index, data, showProgressBar}) : React.JSX.Element => {
  const { t } = useTranslation('library');
  const [completionData, setCompletionData] = useState({
    completion_percentage:null,
    count:0
  })

  const handleCompletionDataFetch = () =>{
    getContentCompletionData({
      program_key: programData?.program_key,
      username:getUserName()
    }, 'program', (data)=>{
      setCompletionData({
        completion_percentage: Math.floor(data.completion_percentage),
        count: data?.count
      })
    })
  }

  useEffect(() => {
    if(showProgressBar){
      handleCompletionDataFetch()
    }
  }, []);

  return (
    <div
      key={index}
      className="item-box path_box"
      id={`w-node-_9d122df3-5436-acb4-d16f-30b76ec43f9d-27264aa9`}
    >
      <Link
        className="link-block-31 w-inline-block"
        to={url}
      >
        <div className="div-block-411">
          <img
            alt=""
            className="image-155"
            loading="lazy"
            sizes="(max-width: 767px) 234px, (max-width: 991px) 295.734375px, (max-width: 1279px) 21vw, 226.5px"
            src="/images/c8.jpg"
            srcSet="/images/c8-p-500.jpeg 500w, /images/c8-p-1080.jpeg 1080w, /images/c8-p-1600.jpeg 1600w, /images/c8-p-2000.jpeg 2000w, /images/c8-p-2600.jpeg 2600w, /images/c8-p-3200.jpeg 3200w, /images/c8.jpg 4288w"
          />
          <div className="label c">
            <div className="text-block-294">{t('PROGRAM')}</div>
          </div>
        </div>
        <div className="item-body">
          <div className="div-block-417">
            <div className="div-block-461">
              <img
                alt=""
                className="image-167"
                loading="lazy"
                sizes="100vw"
                src="images/google.png"
                srcSet="images/google-p-500.png 500w, images/google.png 512w"
              />
            </div>
            <div className="text-block-235">Google</div>
            <div className="div-block-523">
              <div className="text-block-233">120 Skill Coins</div>
            </div>
          </div>
          <div className="text-block-225">{programData?.name || ''}</div>
          <div className="div-block-470">
            <div className="text-block-273">
                      <span className="skill_span">
                        {t('Computer Programming')}
                      </span>
              <span className="skill_span">
                        {t('Python Libraries')}
                      </span>
              <span className="skill_span last">
                        {t('Python Programming')}
                      </span>
            </div>
          </div>
          <div className="div-block-387">
            <img
              alt=""
              className="image-184"
              loading="lazy"
              sizes="100vw"
              src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
              srcSet="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
            />
            <div className="text-block-241">(1k+)</div>
          </div>
          <div className="div-block-389">
            <div className="text-block-287">
              {data?.level && (
                <>
                  {data.level}
                  <strong className="bold-text-7 p"> </strong>
                </>
              )}
              {data?.level && data?.duration && (
                <span className="bullet">
                          <strong className="bold-text-7">•</strong>
                        </span>
              )}
              {data?.duration && (
                <strong className="bold-text-7">{data.duration}</strong>
              )}
            </div>
            <div className="item_options">
              <div className="item_options_triger">
                <img
                  alt=""
                  className="image-182"
                  loading="lazy"
                  src="images/menu_1menu.png"
                />
              </div>
              <div className="options_div">
                <div className="text-block-238">
                  {t('Add to Pathway')}
                </div>
                <div className="text-block-238">
                  {t('Save for Later')}
                </div>
                <div className="text-block-238">{t('Dismiss')}</div>
                <div className="text-block-238">{t('Share')}</div>
                <div className="text-block-238">
                  {t('Create a Pathway')}
                </div>
              </div>
            </div>
          </div>
          {
            showProgressBar && completionData?.completion_percentage ? (
              <div className="w-layout-vflex content-progress-bar-block">
                <div className="w-layout-hflex content-progress-bar-top-block">
                  <div className="content-progress-bar-title">Progress</div>
                  <div className="content-progress-bar-percentage">{completionData?.completion_percentage}%</div>
                </div>
                <div className="content-progress-bar-slider-block">
                  <div className="content-progress-bar-slider-percentage-block" style={{
                    width: `${completionData?.completion_percentage}%`
                  }}></div>
                </div>
              </div>
            ) : <></>
          }

        </div>
      </Link>
    </div>
  )
}